import { synchronize as syncFamilyMember } from '../FamilyMember/synchronize';
import { synchronize as syncProcess } from '../Synchronizable/synchronize';
import { Failed, Success, success } from '../Synchronizable/SyncResult';
import { Family } from './Family';

export async function synchronize(family: Family): Promise<Success> {
  return await syncProcess(family, async progress => {
    const memberPromises = Object.values(family.members).map(syncFamilyMember);
    progress('Waiting for Member Sync');
    const results = await Promise.allSettled(memberPromises);
    const failures = results.filter(result => result.status === 'rejected');
    if (failures.length > 0) {
      const failed: Failed = {
        failure: `${failures.length} of ${memberPromises.length} Members Failed to Sync`,
      };
      // This is a perfectly fine object to indicate failure,
      // and throwing it is the way to reject the promise in an async function.
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw failed;
    }
    return success;
  });
}
